// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsibleFieldSet_container__Gb9P0","label":"CollapsibleFieldSet_label__3ojGq","content":"CollapsibleFieldSet_content__f_NvK"};